import { observable, action } from 'mobx';
import {
    UIModel,
    EUnwrapStage
} from '../models/UIModel';

/**
 * Store for all UI, include model access and all actions on UI state.
 */
export class UIStore {

    @observable
    public ui: UIModel;

    /**
     * UI store is an instance of the UI model.
     *
     * @param {UIModel} ui
     */
    constructor(ui: UIModel) {
        this.ui = ui;
    }

    /**
     * Set the stage of the unwraping process we are in.
     *
     * @param stage
     */
    @action
    public setStage(stage:EUnwrapStage):void
    {
        this.ui.stage = stage;
    }
}

export default UIStore;